import React from "react";
import { Mui, MuiIcons } from "@osu/react-ui";

const classes = {
    list: {
      textAlign: "right",
      width: "95%",
    },
    listItem: {
      padding: 0,
    },
    title: {
      width: "100%",
    },
    tooltipBox: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      width: "100%",
    },
    tooltipText: {
      padding: "5px",
      cursor: "default",
    },
    divider: {
      margin: "0.5rem 0",
    },
  };

const DemographicItem = ({ label, value, tooltip }) => (
  <>
    <Mui.ListItem sx={classes.listItem} tabindex="0">
      <Mui.ListItemText
        sx={classes.title}
        primary={
          <Mui.Typography variant="subtitle2" component="h3">
            {label}
          </Mui.Typography>
        }
      />
      {tooltip ? (
        <Mui.Tooltip title={tooltip} placement="top">
          <Mui.Box sx={classes.tooltipBox}>
            <Mui.Typography component="span" sx={classes.tooltipText}>
              {value}
            </Mui.Typography>
            <MuiIcons.InfoOutlined color="primary" sx={{ fontSize: "12px" }} />
          </Mui.Box>
        </Mui.Tooltip>
      ) : (
        <Mui.ListItemText primary={value} sx={classes.list} />
      )}
    </Mui.ListItem>
    <Mui.Divider sx={classes.divider} />
  </>
);

export default DemographicItem;